import { Component, EventEmitter, Output, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { HintsTypesComponent } from '../hints-types.shared.component';

@Component({
    selector: 'shared-hint-with-indicator',
    templateUrl: './hint-with-indicator.shared.component.html',
    styleUrls: ['./hint-with-indicator.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HintWithIndicatorComponent extends HintsTypesComponent {
    @Input() public iconPositive: string = 'checkmark';
    @Input() public textPositive: string = null;
    @Input() public iconNegative: string = null;
    @Input() public textNegative: string = '!';
    @Input() public iconDisabled: string = 'lock';
    @Input() public textDisabled: string = null;
    @Input() public size: OLO.Components.BUTTON_CIRCLE_SIZE = 'sm';
    @Input() public inverted: boolean = false;
    @Input() public feelPositive: OLO.Components.INDICATOR_FEEL = 'positive-full';
    @Input() public feelNegative: OLO.Components.INDICATOR_FEEL = 'negative-full';
    @Input() public feelDisabled: OLO.Components.INDICATOR_FEEL = 'disabled-full';

    @Input() public hintsHSide: 'left' | 'right' | 'center' = 'right';
    @Input() public hintsVSide: 'top' | 'bottom' | 'center' = 'bottom';
    @Input() public hintsFeel: 'warning' | 'danger' = 'danger';
    @Input() public hintsSize: OLO.Components.FORM_HINTS_SIZE = null;

    @Input() public button: string = null;
    @Output() public onButtonClick: EventEmitter<Event> = new EventEmitter();

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super(changeDetectorRef);
    }

    public handleFloatingButtonClick($event: Event): void {
        this.onButtonClick.emit($event);
    }
}
